"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.searchTerms = searchTerms;
exports.searchBySku = searchBySku;
exports.patchRevision = patchRevision;
exports.createListPriceContractTerm = exports.getContractItems = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _lodash = _interopRequireDefault(require("lodash"));

var _constants = require("./constants");

var _helpers = require("./helpers");

function handleResponse(requestUrl, options) {
  var serviceComment = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  return new Promise(function (resolve, reject) {
    fetch(requestUrl, options).then(_helpers.parseJSON).then(function (response) {
      if (response.ok) {
        return resolve(response.json);
      } // extract the error from the server's json


      return reject({
        serviceComment: serviceComment,
        statusCode: response.status || 0,
        response: response.json || response
      });
    }).catch(function (error) {
      return reject({
        serviceComment: serviceComment,
        statusCode: _lodash.default.get(error, 'response.status', 0),
        response: error
      });
    });
  });
}

var constructRequestBody = function constructRequestBody(skus, name, merchantId, fulfillerId, effectiveStartDate, effectiveEndDate, skuFamily) {
  var comment = skuFamily ? "This list price contract term was created from the Marketplace Catalog for ".concat(skuFamily, ".") : "This list price contract term was created from the Marketplace Catalog.";
  return JSON.stringify({
    skus: skus,
    initiator: {
      type: 'merchants',
      id: merchantId
    },
    acceptor: {
      type: 'fulfillers',
      id: fulfillerId
    },
    buyer: {
      type: 'merchants',
      id: merchantId
    },
    seller: {
      type: 'fulfillers',
      id: fulfillerId
    },
    effectiveStartDate: effectiveStartDate,
    effectiveEndDate: effectiveEndDate,
    toPendingStatus: true,
    additionalData: {
      name: name,
      comment: comment
    }
  });
};

var getContractItems = function getContractItems(termId, revisionId, isProd, onGetAccessToken) {
  var pricingTermUrl = isProd ? _constants.PRICING_TERM_PRD : _constants.PRICING_TERM_NONPRD;
  var requestUrl = "".concat(pricingTermUrl, "/api/v0/terms/").concat(termId, "/revisions/").concat(revisionId, "/items");
  var headers = new Headers({
    'Content-Type': 'application/json',
    Authorization: "Bearer ".concat(onGetAccessToken())
  });
  var options = {
    method: 'GET',
    mode: 'cors',
    headers: headers
  };
  return handleResponse(requestUrl, options);
};

exports.getContractItems = getContractItems;

var createListPriceContractTerm = function createListPriceContractTerm(fulfillerId, merchantId, skus, name, effectiveStartDate, effectiveEndDate, skuFamily, onGetAccessToken, isProd) {
  var pricingTermUrl = isProd ? _constants.PRICING_TERM_PRD : _constants.PRICING_TERM_NONPRD;
  var body = constructRequestBody(skus, name, merchantId, fulfillerId, effectiveStartDate, effectiveEndDate, skuFamily);
  var requestUrl = "".concat(pricingTermUrl, "/api/v0/listPriceTerms");
  var headers = new Headers({
    Accept: 'application/json',
    'Content-Type': 'application/json-patch+json',
    Authorization: "Bearer ".concat(onGetAccessToken())
  });
  var options = {
    method: 'POST',
    mode: 'cors',
    headers: headers,
    body: body
  };
  return handleResponse(requestUrl, options);
};

exports.createListPriceContractTerm = createListPriceContractTerm;

function searchTerms(_x, _x2, _x3) {
  return _searchTerms.apply(this, arguments);
}

function _searchTerms() {
  _searchTerms = (0, _asyncToGenerator2.default)(
  /*#__PURE__*/
  _regenerator.default.mark(function _callee(seller, buyer, onGetAccessToken) {
    var isProd,
        pricingTermUrl,
        requestUrl,
        headers,
        body,
        options,
        _args = arguments;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            isProd = _args.length > 3 && _args[3] !== undefined ? _args[3] : true;
            pricingTermUrl = isProd ? _constants.PRICING_TERM_PRD : _constants.PRICING_TERM_NONPRD;
            requestUrl = "".concat(pricingTermUrl, "/api/v0/terms:search");
            headers = new Headers({
              Accept: 'application/json',
              'Content-Type': 'application/json-patch+json',
              Authorization: "Bearer ".concat(onGetAccessToken())
            });
            body = {
              buyerId: buyer.id,
              buyerType: buyer.type,
              sellerId: seller.id,
              sellerType: seller.type
            };
            options = {
              method: 'POST',
              mode: 'cors',
              headers: headers,
              body: JSON.stringify(body)
            };
            return _context.abrupt("return", handleResponse(requestUrl, options));

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this);
  }));
  return _searchTerms.apply(this, arguments);
}

function searchBySku(_x4, _x5, _x6) {
  return _searchBySku.apply(this, arguments);
}

function _searchBySku() {
  _searchBySku = (0, _asyncToGenerator2.default)(
  /*#__PURE__*/
  _regenerator.default.mark(function _callee2(skus, seller, onGetAccessToken) {
    var isProd,
        pricingTermUrl,
        requestUrl,
        searchRequest,
        headers,
        body,
        options,
        _args2 = arguments;
    return _regenerator.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            isProd = _args2.length > 3 && _args2[3] !== undefined ? _args2[3] : true;
            pricingTermUrl = isProd ? _constants.PRICING_TERM_PRD : _constants.PRICING_TERM_NONPRD;
            requestUrl = "".concat(pricingTermUrl, "/api/v0/activeterms:searchbysku");
            searchRequest = {
              skus: skus,
              seller: seller
            };
            headers = new Headers({
              Accept: 'application/json',
              'Content-Type': 'application/json-patch+json',
              Authorization: "Bearer ".concat(onGetAccessToken())
            });
            body = searchRequest;
            options = {
              method: 'POST',
              mode: 'cors',
              headers: headers,
              body: JSON.stringify(body)
            };
            return _context2.abrupt("return", handleResponse(requestUrl, options));

          case 8:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, this);
  }));
  return _searchBySku.apply(this, arguments);
}

function patchRevision(_x7, _x8, _x9, _x10) {
  return _patchRevision.apply(this, arguments);
}

function _patchRevision() {
  _patchRevision = (0, _asyncToGenerator2.default)(
  /*#__PURE__*/
  _regenerator.default.mark(function _callee3(id, latestRevisionId, skus, onGetAccessToken) {
    var isProd,
        toApproved,
        pricingTermUrl,
        requestUrl,
        value,
        path,
        op,
        patchPriceTermRequest,
        headers,
        body,
        options,
        _args3 = arguments;
    return _regenerator.default.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            isProd = _args3.length > 4 && _args3[4] !== undefined ? _args3[4] : true;
            toApproved = _args3.length > 5 && _args3[5] !== undefined ? _args3[5] : false;
            pricingTermUrl = isProd ? _constants.PRICING_TERM_PRD : _constants.PRICING_TERM_NONPRD;
            requestUrl = "".concat(pricingTermUrl, "/api/v0/terms/").concat(id, "/revisions");
            value = skus.map(function (sku) {
              return {
                sku: sku
              };
            });
            path = '/items';
            op = 'replace';
            patchPriceTermRequest = [{
              value: value,
              path: path,
              op: op
            }];
            headers = new Headers({
              Accept: 'application/json',
              'Content-Type': 'application/json',
              Authorization: "Bearer ".concat(onGetAccessToken())
            });
            body = {
              toApproved: toApproved,
              latestRevisionId: latestRevisionId,
              patchPriceTermRequest: patchPriceTermRequest
            };
            options = {
              method: 'POST',
              mode: 'cors',
              headers: headers,
              body: JSON.stringify(body)
            };
            return _context3.abrupt("return", handleResponse(requestUrl, options));

          case 12:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, this);
  }));
  return _patchRevision.apply(this, arguments);
}